import { AccessGrant, Query, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import { removeFields } from 'mocks/graphqlMocks/removeFields';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';

export function mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledData(
  getVisitorGroupsForTenant: Array<VisitorGroup>
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return {
    getVisitorGroupsForTenant
  };
}

const fieldsToRemoveFromVisitorGroups: (keyof VisitorGroup)[] = [
  'allowedAccessGrants',
  'defaultAccessGrants',
  'scheduledAccessGrants',
  'isAdminGroup',
  'isQrCodeVisitInviterGroup',
  'maxNumberOfMembers',
  'members',
  'memberIds',
  'tenantId'
];

const fieldsToRemoveFromAccessGrant: (keyof AccessGrant)[] = [
  'accessSchedule',
  'doors',
  'doorIds',
  'locations',
  'locationIds',
  'name',
  'tenantId'
];

export const mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataForQuery =
  mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledData([
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupId0',
        accessGrants: [
          removeFields(generateMockAccessGrant({ id: 'mockedAccessGrantId0' }), fieldsToRemoveFromAccessGrant)
        ]
      }),
      fieldsToRemoveFromVisitorGroups
    ),
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupId1',
        accessGrants: [
          removeFields(
            generateMockAccessGrant({ id: 'mockedAccessGrantId1', isOfficeModeEnabled: false }),
            fieldsToRemoveFromAccessGrant
          )
        ]
      }),
      fieldsToRemoveFromVisitorGroups
    )
  ]);

export const mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataAdmin =
  mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledData([
    generateMockVisitorGroup({
      id: 'mockedIdInstallers',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdInstallers' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdCleaners',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdCleaners' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdCo-contractors',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdCo-contractors' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdAdmins',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdAdmins' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdEmployees',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdEmployees' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitor_group_1',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdVisitor_group_1' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitor_group_2',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdVisitor_group_2' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitor_group_3',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdVisitor_group_3' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitors',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdVisitors' })]
    })
  ]);
